(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const links = Array.from(document.querySelectorAll('.dd-rail a[href^="#"]'));
    if (!links.length) return;

    const sections = links
      .map(a => document.querySelector(a.getAttribute("href")))
      .filter(Boolean);

    const select = document.querySelector(".dd-mobile-jump select");

    function setActive(hash) {
      links.forEach(a => {
        a.classList.toggle("is-active", a.getAttribute("href") === hash);
      });

      if (select && hash && select.value !== hash) {
        select.value = hash;
      }
    }

    // 1) Click: lascia fare allo scroll nativo (anchor), ma aggiorna subito lo stato UI
    links.forEach(a => {
      a.addEventListener("click", () => {
        const hash = a.getAttribute("href");
        if (hash) setActive(hash);
      });
    });

    // 2) Scroll-spy robusto: sezione più vicina al top
    let ticking = false;

    function pickActive() {
      ticking = false;

      // Se hai header sticky di Dawn, questo offset evita che “sballi”
      const offset = 140;

      let bestSection = null;
      let bestDistance = Infinity;

      for (const sec of sections) {
        const dist = Math.abs(sec.getBoundingClientRect().top - offset);
        if (dist < bestDistance) {
          bestDistance = dist;
          bestSection = sec;
        }
      }

      if (bestSection && bestSection.id) {
        setActive("#" + bestSection.id);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(pickActive);
    }

    window.addEventListener("scroll", onScroll, { passive: true });

    // 3) Mobile jump
    if (select) {
      select.addEventListener("change", () => {
        const hash = select.value;
        if (!hash) return;
        setActive(hash);
        location.hash = hash; // anchor nativo
      });
    }

    // Init
    if (location.hash && document.querySelector(location.hash)) {
      setActive(location.hash);
    } else if (sections[0]) {
      setActive("#" + sections[0].id);
    }

    // Una passata iniziale (dopo che Dawn ha finito layout/font)
    setTimeout(pickActive, 80);
  });
})();